import { EmbeddedCheckout, EmbeddedCheckoutProvider } from "@stripe/react-stripe-js";
import { StripeEmbeddedCheckoutOptions, loadStripe } from "@stripe/stripe-js";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Expert from "../../../components/Expert";
import LoadingSpinner from "../../../components/LoadingSpinner";
import { BASE_URL, STRIPE_KEY } from "../../../utils/Constants";
import "./css/CheckoutForm.css";

const stripePromise = loadStripe(STRIPE_KEY);

interface Props {
    idToken: string,
    userId: string,
    mode: string,
    bundleType: string,
    nutritionist: Expert,
}

const CheckoutForm: React.FC<Props> = ({
    idToken,
    userId,
    mode,
    bundleType,
    nutritionist,
}) => {

    const navigate = useNavigate()

    useEffect(() => {
        fetchClientSecret()
    }, [])

    const [isComplete, setIsComplete] = useState(false)

    const requestOptions = {
        method: 'GET',
        headers: {
            'Authorization': idToken!
        }
    }

    async function callGetOrdersByUserIdApi() {
        const response = await fetch(`${BASE_URL}/api/orders/user/${userId}`, requestOptions)
        if (!response.ok) {
        } else {
            const responseJson = await response.json()
            console.log(responseJson)
            navigate(`/survey-a-home`, { state: { userId, idToken, accessToken: "", productName: "", name: "" } },)
        }
    }

    async function fetchClientSecret() {
        const response = await fetch(`${BASE_URL}/api/payment/create-checkout-session`, {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': idToken
            },
            body: JSON.stringify(
                {
                    mode: mode,
                    user_id: userId,
                    environemnt: "local",
                    bundle_type: bundleType,
                }
            )
        })
        const data = await response.json()
        return data.client_secret
    }

    const handleIsComplete = () => {
        setIsComplete(true)
        // callAPIAssignMedicalUserToPatient()
        setTimeout(() => {
            callGetOrdersByUserIdApi()
        }, 2000)
    }
    const options: StripeEmbeddedCheckoutOptions = { fetchClientSecret, onComplete: handleIsComplete };

    const requestOptionsGET = {
        method: 'GET',
        headers: {
            'Authorization': idToken!
        }
    }

    const [isLoading, setIsLoading] = useState(false)

    // ASSIGN specialist to a user
    async function callAPIAssignMedicalUserToPatient() {
        setIsLoading(true)
        const responseUserinfo = await fetch(`${BASE_URL}/api/medical-user/assign/`, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': idToken!,
            },
            body: JSON.stringify(
                {
                    patient_id: userId,
                    medicaluser_id: nutritionist?.id,
                })
        })
        setIsLoading(false)
        if (responseUserinfo.ok) {
            const responseJson = await responseUserinfo.json()
            console.log(responseJson)
        } else if (responseUserinfo.status === 401) {
            // call refreshToken
            navigate("/login")
        } else {
            const responseJson = await responseUserinfo.json()
            console.log(responseJson)
        }
    }

    return (
        isComplete ?
            <div className="App justify_content_center relative">
                <div className="checkout-form-success-container">
                    <div className="checkout-form-success-heading">
                        Ordine effettuato correttamente
                    </div>
                    <div className="checkout-form-success-copy">
                        Attendi un momento
                    </div>
                    <div className="height_35" />
                    <LoadingSpinner />
                </div>
            </div>
            :
            <div
                className=""
                id="checkout"
            >
                <EmbeddedCheckoutProvider
                    stripe={stripePromise}
                    options={options}
                >
                    <EmbeddedCheckout />
                </EmbeddedCheckoutProvider>
            </div>
    )
}

export default CheckoutForm
